/* es-lint disable */
// Evita que o erro do ResizeObserver interrompa a tela com o overlay do Webpack
window.addEventListener('error', (e) => {
  if (
    e.message ===
      'ResizeObserver loop completed with undelivered notifications.' ||
    e.message === 'ResizeObserver loop limit exceeded'
  ) {
    e.stopImmediatePropagation();
  }
});

import * as icons from '@mdi/js';
import Toaster from '@meforma/vue-toaster';
import { createApp } from 'vue';
// Vuetify
import 'vuetify/styles';
import '@mdi/font/css/materialdesignicons.css';
import { createRouter, createWebHistory } from 'vue-router';
import { createVuetify } from 'vuetify';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

import App from '@/App.vue';
import routes from '@/router/router';
import store from '@/store/store';

import '@/assets/css/tailwind.css';
import '@mdi/font/css/materialdesignicons.css';

/**
 * Configuração global do Vuetify
 * @typedef {Object} VuetifyConfig
 * @property {Object} components - Componentes registrados globalmente
 * @property {Object} directives - Diretivas registradas globalmente
 * @property {Object} icons - Ícones registrados globalmente
 * @property {Object} icons.values - Valores dos ícones registrados
 */

/**
 * Cria uma nova instância do Vuetify
 * @function createVuetify
 * @param {VuetifyConfig} options - Opções de configuração do Vuetify
 * @returns {Vuetify} Instância do Vuetify
 */
const vuetify = createVuetify({
  components,
  directives,
  icons: {
    values: icons,
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#0B3D6E',
          warning: '#cccc00ff',
        },
      },
    },
  },
});

/* eslint-disable */
/**
 * Cria um novo objeto de router para um Aplicativo Vue.
 * @function createRouter
 * @param {Object} options - Opções para criar um novo objeto router.
 * @param {Object} options.history - O tipo de histórico a ser usado com o objeto router.
 * @param {Array} options.routes - As rotas a serem utilizadas com o objeto router.
 * @returns {Router} Um novo objeto router
 */
const router = createRouter({
  history: createWebHistory(),
  routes, // short for `routes: routes`
});

/**
 * Verifica se o usuário está autenticado em rotas que exigem autenticação
 *
 * @param {Object} to - O objeto que representa a rota de destino
 * @param {Object} from - O objeto que representa a rota atual
 * @param {Function} next - A função que deve ser chamada para continuar a navegação
 * @returns {void}
 */
router.beforeEach((to, from, next) => {
  const getToken = () => localStorage.getItem('token');
  const token = store.state.token;
  // Se a rota precisar de autenticação
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Verifique se o usuario está autenticado
    /**
     * Obtém o token salvo no localStorage
     *
     * @returns {string|null} O token salvo ou null se não estiver salvo
     */
    if (!getToken() || getToken() != token) {
      next({
        path: '/login',
        query: { redirect: to.fullPath },
      });
    } else {
      // verifica se a rota tem o parametro id_proj
      const userType = localStorage.getItem('funcao');
      if (to.params.id_proj !== undefined) {
        if (userType === 'Usuario Testador') {
          return next();
        }
        const idProjectList = JSON.parse(localStorage.getItem('idProjectList')) || [];
        if (idProjectList.indexOf(parseInt(to.params.id_proj)) === -1) {
          return next({
            path: '/projects',
          });
        }
        return next();
      }

      if (to.params.idProjeto !== undefined) {
        if (userType === 'Usuario Testador') {
          return next();
        }
        const idProjectList = JSON.parse(localStorage.getItem('idProjectList')) || [];
        if (idProjectList.indexOf(parseInt(to.params.idProjeto)) === -1) {
          return next({
            path: '/projects',
          });
        }
        return next();
      }
      return next();
    }
  } else {
    next();
  }
});
/* eslint-enable */

createApp(App).use(Toaster).use(vuetify).use(router).use(store).mount('#app');

export default router;
